import { render, staticRenderFns } from "./dailyluckList.vue?vue&type=template&id=00609d0c&scoped=true"
import script from "./dailyluckList.vue?vue&type=script&lang=js"
export * from "./dailyluckList.vue?vue&type=script&lang=js"
import style0 from "./dailyluckList.vue?vue&type=style&index=0&id=00609d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00609d0c",
  null
  
)

export default component.exports